import { useRef as r } from "react";
const t = () => {
  const t2 = r(true);
  return t2.current ? (t2.current = false, true) : t2.current;
};
export {
  t as useFirstMountState
};
//# sourceMappingURL=useFirstMountState.js.map
